import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import ValidationService from "@/services/ValidationService";

export default {
  name: 'tuitionPaymentEdit',
  components: {
    MainLayout,
    Loading,
    flatPickr,
  },
  mixins: [ValidationService],
  data() {
    return {
      isLoading: true,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      tuitionPaymentInfo: {},
      CONFIG,
      PaymentHistories: [],
      STATUS: CONFIG.PAYMENT_HISTORY_STATUS_VAL,
      currency_txt: '',
      baseAmounts: [],
      originalQuantities: [],
      maxQuantity: 999,
      taxRate: 0,
    };
  },

  computed: {
    studentPaymentId() {
      return this.$route.params.studentPaymentId;
    },

    totalApprovedAmount() {
      return this.PaymentHistories.reduce((sum, history) => {
        if (Number(history.status) === this.STATUS.APPROVED) {
          return sum + Number(history.amount || 0);
        }
        return sum;
      }, 0);
    },
  },

  methods: {
    /**
     * Redirect to statement list
     */
    showStatementList() {
      this.$router.push({
        path: "/student/statement/list"
      });
    },

    update() {
      this.disabled = true;
      this.clearValidationErrors();
      this.isLoading = true;
      const request = {
        due_date: this.tuitionPaymentInfo.due_date,
        gross_total_amt: this.tuitionPaymentInfo.gross_total_amt,
        net_total_amt: this.tuitionPaymentInfo.net_total_amt,
        tax: this.tuitionPaymentInfo.tax,
        grand_total_amt: this.tuitionPaymentInfo.grand_total_amt,
        payment_details: (this.tuitionPaymentInfo.payment_details || []).map(detail => ({
          id: detail.id,
          item_id: detail.item ? detail.item.id : detail.item_id,
          quantity: detail.quantity,
          amount: detail.amount,
          net_amount: detail.net_amount,
          item_type: detail.item.item_type
        })),
      }
      axios.patch(`student/statement/detail/${this.$route.params.tuitionPaymentId}/tuition-payment/${this.$route.params.studentPaymentId}`, request)
      .then((response) => {
        if (response.data.success === true) {
          this.isLoading = false;
          this.$notification.success("Tuition Payment successfully updated.", {
            timer: 3,
            position: "bottomCenter",
          });
          this.showStatementDetail()
        }
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else if (error.response.status == 422) {
          this.printValidationError(error.response);
        } else if (error.response.status === 500) {
          this.$notification.error("Failed to update for tuition payment.", {
              timer: 3,
              position: "bottomCenter",
            });
        }
        console.error("Error update payment by plan:", error);
      })
    },

    getTuitionPaymentDetailByPlan() {
      this.isLoading = true;
      axios.get(`student/statement/detail/${this.$route.params.tuitionPaymentId}/tuition-payment/${this.$route.params.studentPaymentId}`)
      .then((response) => {
        if (response.data.success === true) {
          this.isLoading = false;
          this.tuitionPaymentInfo = response.data.data;
          this.currency_txt = response.data.currency_txt;

        if (this.tuitionPaymentInfo.payment_history_status === CONFIG.PARENT_PAYMENT_STATUS.FULLY_PAID) {
            this.$notification.error("Cannot edit paid payment.", {
              timer: 3,
              position: "bottomCenter",
            });
            this.showStatementDetail();
            return;
          }
          this.initPaymentDetails();
        }
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error("Error fetching payment info by plan:", error);
      })
    },

    isFirstPayment() {
        const periodStr = this.tuitionPaymentInfo.period || '';
        
        if (!periodStr.includes('#')) {
            return periodStr.length > 0;
        }
        
        const num = parseInt(periodStr.split('#').pop(), 10);
        return num === 1;
    },

    initPaymentDetails() {
      const details = this.tuitionPaymentInfo.payment_details || [];
      this.baseAmounts = details.map(detail => {
        const currentQty = Number(detail.quantity) > 0 ? Number(detail.quantity) : 1;
        const currentAmount = Number(detail.amount) || 0;
        const currentNetAmount = Number(detail.net_amount) || 0;
        return {
          base_amount: currentAmount / currentQty,
          base_net_amount: currentNetAmount / currentQty,
        };
      });
      this.originalQuantities = details.map(detail => Math.max(1, Math.floor(Number(detail.quantity) || 1)));
      details.forEach(detail => {
        if (detail.quantity === undefined || detail.quantity === null || Number(detail.quantity) < 1) {
          detail.quantity = 1;
        } else {
          detail.quantity = Math.min(this.maxQuantity, Math.floor(Number(detail.quantity)));
        }
      });
    },

    calculateNetTotal(index) {
      const detail = this.tuitionPaymentInfo.payment_details[index];
      const base = this.baseAmounts[index];
      if (!detail || !base) return;

      let qty = Number(detail.quantity);
      if (!Number.isFinite(qty) || qty < 1) qty = 1;
      const maxQty = this.originalQuantities[index] || this.maxQuantity;
      if (qty > maxQty) qty = maxQty;
      qty = Math.floor(qty);
      detail.quantity = qty;

      detail.amount = base.base_amount * qty;
      detail.net_amount = base.base_net_amount * qty;

      this.recalculateTotals();
    },

    removePaymentDetail(index) {
      this.tuitionPaymentInfo.payment_details.splice(index, 1);
      this.baseAmounts.splice(index, 1);
      this.originalQuantities.splice(index, 1);
      this.recalculateTotals();
    },

    recalculateTotals() {
      const details = this.tuitionPaymentInfo.payment_details || [];
      const grossTotal = details.reduce(
        (sum, d) => sum + (Number(d.amount) || 0),
        0,
      );

      let discountAmount = 0;
      if (this.tuitionPaymentInfo.is_discount) {
        discountAmount = Number(this.tuitionPaymentInfo.discount_amount) || 0;
      }

      let calculatedDiscountAmt = 0;
      if (
        this.tuitionPaymentInfo.student_payment_discounts &&
        this.tuitionPaymentInfo.student_payment_discounts.length > 0
      ) {
        calculatedDiscountAmt = Number(this.tuitionPaymentInfo.calculated_discount_amt) || 0;
      }

      const netTotal = Math.max(0, grossTotal - discountAmount - calculatedDiscountAmt);
      const tax = Math.round(netTotal * this.taxRate);
      const grandTotal = netTotal + tax;

      this.tuitionPaymentInfo.gross_total_amt = grossTotal;
      this.tuitionPaymentInfo.net_total_amt = netTotal;
      this.tuitionPaymentInfo.tax = tax;
      this.tuitionPaymentInfo.grand_total_amt = grandTotal;
    },

    getTaxRate() {
      axios.get(`setting/get-tax-rate`)
        .then(res => {
          this.taxRate = res.data.tax_rate;
          if (
            this.tuitionPaymentInfo &&
            this.tuitionPaymentInfo.payment_details &&
            this.tuitionPaymentInfo.payment_details.length > 0
          ) {
            this.recalculateTotals();
          }
        })
        .catch(err => {
          console.log(err);
          this.taxRate = CONFIG.TAX_RATE;
          if (
            this.tuitionPaymentInfo &&
            this.tuitionPaymentInfo.payment_details &&
            this.tuitionPaymentInfo.payment_details.length > 0
          ) {
            this.recalculateTotals();
          }
        });
    },

    isLateFeeItem(detail) {
      if (!detail) return false;
      if (detail.item && detail.item.is_late_fee !== undefined) {
        return Boolean(detail.item.is_late_fee);
      }
      const itemType = detail.item ? detail.item.item_type : detail.item_type;
      return Number(itemType) === CONFIG.PAYMENT_ITEM_TYPES_Id.lateFee;
    },

    getHistoryList() {
      axios.get(`student-payment/${this.studentPaymentId}/payment-history/list`)
      .then((response) => {
        this.PaymentHistories = response.data.histories || [];
        this.currency_txt = response.data.currency_txt;
      })
      .catch(error => {
        console.error("Error tuition payment history:", error);
      });
    },

    /**
     * Redirect to statement detail or payment list based on the source
     */
    showStatementDetail() {
      if (this.$route.query.from === 'payment-list') {
        this.$router.push({ name: 'paymentList' });
        return;
      }
      this.$router.push({
        path: `/student/statement/detail/${this.$route.params.tuitionPaymentId}`
      });
    }
  },

  mounted() {
    this.isLoading = true;
    this.getTaxRate();
    this.getTuitionPaymentDetailByPlan();
    this.getHistoryList();
  },
};
